<template>
  <div>
    <el-row>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="matchProduct" style="margin-top:20px">匹配项目</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="项目名称" prop="PROJECT_NAME"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="deleteProduct(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 新增匹配 -->
    <el-dialog title="新增匹配" center :visible.sync="addFormVisible" width="400px">
      <el-form size="small" :model="addForm" ref="addForm">
        <el-form-item label="分组名称：" :label-width="formLabelWidth">
          <el-select filterable v-model="addForm.CUSTOMER">
            <el-option v-for="item in customerList" :key="item.PROJECT_ID" :value="item.ID" :label="item.PROJECT_NAME">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getClientGroupCusFun, deleteClientMatchCusFun, getClientNotMatchCusFun, ClientmatchCusFun,
} from 'api/systemSetting';

export default {
  data() {
    return {
      tableData: [],
      kindsId: sessionStorage.getItem('areaId'),
      customerList: [],
      addFormVisible: false,
      addForm: {},
      formLabelWidth: '100px',
    };
  },
  methods: {
    matchProduct() {
      this.addFormVisible = true;
      this.queryNotMatch();
    },
    // ---------------------------进入页面拉取数据
    queryTable() {
      const params = {};
      getClientGroupCusFun(params)
        .then((result) => {
          if (result[0]) {
            this.tableData = result;
          } else {
            this.tableData = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ------------------------------删除数据
    deleteProduct(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            PROJECT_ID: row.PROJECT_ID,
          };
          deleteClientMatchCusFun(params)
            .then((result) => {
              this.$message.show({ text: '删除成功', type: 'success' });
              this.queryTable();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally { }
      }
    },
    queryNotMatch() {
      const params = {};
      getClientNotMatchCusFun(params)
        .then((result) => {
          this.customerList = result;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            PROJECT_ID: this.addForm.CUSTOMER,
          };
          if (!this.addForm.CUSTOMER) {
            this.$message.show({ text: '请选择分组名称', type: 'warning' });
            return false;
          }
          ClientmatchCusFun(params)
            .then((result) => {
              this.$message.show({ text: '新增成功', type: 'success' });
              this.addFormVisible = false;
              this.queryTable();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally { }
      }
    },
    handleCurrentChange() {
      this.queryTable();
    },
    close() {
      this.addFormVisible = false;
    },
  },
  created() {
    this.queryTable();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/customerManage/matchClientGroup.vue